import React, { useState } from 'react';
import '../../entrydoor.css';

const WeatherStripColor = ({ value, onChange, label = 'Weather Strip Color:' }) => {
    const [selectedWeatherStripColor, setSelectedWeatherStripColor] = useState(value || "");

    const handleWeatherStripColorChange = (e) => {
        setSelectedWeatherStripColor(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="WeatherStripColor">{label}</label>
            <select
                id="WeatherStripColor"
                value={selectedWeatherStripColor}
                onChange={handleWeatherStripColorChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Black">{selectedWeatherStripColor === "Black" ? "Black ✔" : "Black"}</option>
            </select>
        </div>
    );
};

export default WeatherStripColor;
